import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  price: PropTypes.number.isRequired,
};

export function UnstyledPrice({ price, classes }) {
  const priceString = (price / 100).toFixed(2);
  return <div className={classes.price}>${priceString}</div>;
}

UnstyledPrice.propTypes = propTypes;

const styles = (theme) => ({
  price: {
    ...theme.typography.h5,
    color: theme.customColors.mediumGrey,
    fontWeight: 500,
    fontSize: 21,
    flex: 0.01,
  },
  asterisk: {
    fontSize: '20px',
    color: theme.customColors.magenta,
  },
});

export default withStyles(styles)(UnstyledPrice);
